import React from 'react';
import { PayslipList } from '../payslips';

const PayslipListWrapper: React.FC = () => {
  return <PayslipList />;
};

export default PayslipListWrapper;